
import {of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { LookupApi } from 'src/features/common/modal/modal-feature-types';

import { ApiHelper } from 'cad/common/services/api/api-helper';

@Injectable()
export class AssociateContactSecurityApi implements LookupApi {

  private readonly endpoint: string = 'associate/contact/';
  private readonly suffix: string = '/security';

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public filter(params: any): Observable<any> {
    let returnVal: Observable<any>;
    if (params) {
      let paramsObj: any = _.omit(params, 'populator');
      returnVal = this.findUsers(paramsObj);
    }
    return !_.isNil(returnVal) ? returnVal : observableOf([]);
  }

  public findAll = (data: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + data.contactId + this.suffix + '/all', {body: data});
  }

  public findUsers = (data: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + data.userId + this.suffix + '/find-users', {body: data});
  }

  public getAvailableUserSecurityRoles = (data: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + data.userId + this.suffix + '/avail-roles', {body: data});
  }

  public save = (data: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + data.userId + this.suffix + '/save', {body: data});
  }

  public delete = (data: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + data.userId + this.suffix + '/delete', {body: data});
  }

  public getAddSecurityRoles = (data: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + data.userId + this.suffix + '/add-roles', {body: data});
  }

  
  public generateExtUserId = (data: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + data.userId + this.suffix + '/generate-id', {body: data});
  }

  public unassignedUsers = (data: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + data.userId + this.suffix + '/unassigned-users', {body: data});
  }

}
